<template>
  <card-component title="Ingresa tu usuario de Woekvivo" icon="lock" :has-card-header-background="true" :has-button-slot="true">
    <div class="control">
    <b-button native-type="submit" class="button is-primary" expanded :class="{'is-loading':isLoadingStartClaim}">
        Activar Cuenta
    </b-button>
    <button @click="goToLogin">Iniciar sesión</button>
    <button @click="goToChangePassword">Cambiar contraseña</button>
    </div>
  </card-component>
</template>

<script>
import CardComponent from '@/components/CardComponent'
export default {
  name: 'ChooseStartClaim',
  components: { CardComponent },
  data () {
    return {
      isLoadingStartClaim: false,
      dni: null
    }
  },
  methods: {
    goToLogin () {
      this.$router.push('/login')
    },
    goToChangePassword () {
      this.$router.push('/cambiar-contrasena')
    }
  }
}
</script>
